import { getEnvSettings } from '../configurationServices'
import { getFingerprint } from 'src/utils/fingerprint'
import {
  ProductOnlineCheckRequest,
  ProductOnlineCheckResponse,
  ProductOnlineCheckError,
} from './types'

const { REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL, OIDC_STORAGE_KEY } = getEnvSettings()

interface OidcUser {
  access_token: string
  token_type: string
  expires_at: number
}

/**
 * Gets the stored token from session storage using OIDC key
 */
const getStoredToken = (): string | null => {
  try {
    const storedData = sessionStorage.getItem(OIDC_STORAGE_KEY)

    if (!storedData) {
      console.error('getStoredToken - No OIDC data found in session storage')
      return null
    }

    const oidcUser: OidcUser = JSON.parse(storedData)
    return oidcUser?.access_token || null
  } catch (error) {
    console.error('getStoredToken - Error parsing OIDC data:', error)
    return null
  }
}

/**
 * Fetches the product online check data
 * @param adminUserId - The admin user ID (UUID)
 * @returns Promise with the list of products
 */
export const fetchProductOnlineCheck = async (
  adminUserId: string,
): Promise<ProductOnlineCheckResponse> => {
  const token = getStoredToken()

  if (!token) {
    throw new ProductOnlineCheckError('Token no encontrado en session storage', 'AUTH_ERROR')
  }

  const fingerprint = await getFingerprint()

  const requestBody: ProductOnlineCheckRequest = {
    fingerprint: 'admin',
  }

  const response = await fetch(
    `${REACT_APP_PB_API_TICKET_INQUIRY_BASE_URL}/search/productOnlineCheck/GH478-U45OI`,
    {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'x-admin-user': adminUserId,
        'X-fingerprint': fingerprint,
        Origin: 'https://admin.placebet.com.do',
      },
      body: JSON.stringify(requestBody),
    },
  )

  let responseData: ProductOnlineCheckResponse

  try {
    responseData = await response.json()
  } catch {
    throw new ProductOnlineCheckError(
      `No se pudo procesar la respuesta del servidor: ${response.status} ${response.statusText}`,
      response.ok ? 'UNKNOWN' : `${response.status}`,
    )
  }

  // Check if response is ok
  if (!response.ok) {
    throw new ProductOnlineCheckError(
      `Error al obtener los productos (${response.status})`,
      `${response.status}`,
    )
  }

  // Validate response data structure
  if (!responseData.data || !Array.isArray(responseData.data)) {
    throw new ProductOnlineCheckError('Respuesta del servidor inválida', 'INVALID_RESPONSE')
  }

  return responseData
}
